import { ProductV2 } from '@common'
import cx from 'classnames'
import { useTranslations } from 'next-intl'

import { getStampCardTranslationKeys } from '@/localization/utils'

import { StampCard } from '../stampCard/StampCard'
import { StoreTypography } from '../typography/StoreTypography'

import styles from './info.module.scss'

type Props = {
  product: ProductV2
}
export function PassesInfo({ product }: Props) {
  const t = useTranslations()
  const keys = getStampCardTranslationKeys(product.game)

  if (!keys) {
    return null
  }

  const title = t(`stamps_info_${keys.product}_purchases`)
  const description = t(`stamps_info_${keys.product}_stamp_card`)
  const info = t(`stamps_info`)

  return (
    <div className={cx(styles.info, styles.passesInfo)}>
      <div className={styles.infoContent}>
        <StoreTypography tag="h5" style="plain" textSize="body" overrideFont="supercellTextMedium">
          {title}
        </StoreTypography>
        <div className={styles.passesInfoImage}>
          <StampCard product={product} size="large" />
        </div>
        <p>{description}</p>
        <p>{info}</p>
      </div>
    </div>
  )
}
